import { faAngleLeft, faEdit, faFileCsv } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';

//components
import TextField from '../../../../../components/TextField';
import TabelaListagem from '../../../../../components/TabelaListagem/TabelaListagem';
import ModalRecalculoInfracoes from './ModalRecalculoInfracoes';
import TabelaRecalculoInfracoes from './ListaRecalculoInfracoes';
import HistoricoReajustesInfracoes from './HistoricoReajustesInfracoes';

//Helpers
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../../../helpers/message';
import mascaras from '../../../../../helpers/mascaras';

//Context
import { useAuth } from '../../../../../context/auth';

//API
import infracoes_api from '../../../../../api/infracoes_api';
import { actionsTable } from '../../../../../constants/MaterialTable';
import moment from 'moment';
import { CSVLink } from 'react-csv';

function initialStateInfracao() {
  return {
    identificacao: "",
    status: "Ativo",
    clausula: "",
    codigoTipoServico: "",
    valor: "0,00",
    tipoInfracao: "Multa",
    htmlImpressao: "",
    secretaria_Id: "",
    valorReincidencia: "0,00",
    tipofiscalizacao_Id: ""
  }
};

export default function ListaInfracoesPorTipoFiscalizacao({ tipofiscalizacao_Id, handleVoltar, editavel = false, podeRecalcular = false }) {
  const { session, setLoading } = useAuth();

  // State para armazenar os dados da infração em edição/criação
  const [infracao, setInfracao] = useState(initialStateInfracao());

  // State para armazenar a lista completa de infrações cadastradas
  const [infracoes, setInfracoes] = useState([]);

  // Controla a visibilidade do formulário de criação/edição de infração
  const [visibleForm, setVisibleForm] = useState(false);

  // Armazena os erros de validação dos campos do formulário
  const [errors, setErrors] = useState({});

  // Controla a exibição do modal de recálculo de infrações
  const [openRecalculoModal, setOpenRecalculoModal] = useState(false);

  // Reajuste em preparo: dados informados no modal + prévia editável das infrações (null quando não há)
  const [reajusteEmPreparo, setReajusteEmPreparo] = useState(null);

  // Histórico de reajustes (agendados, aplicados e cancelados) deste tipo de fiscalização
  const [reajustes, setReajustes] = useState([]);

  // Indica se já existe um reajuste agendado para este tipo de fiscalização
  const possuiReajusteAgendado = reajustes.some(reajuste => reajuste.status === "Agendado");

  //State para pegar historicos de alteração das infrações
  const [listaHistoricoInfracao, setListaHistoricoInfracao] = useState([]);

  //State para pegar historicos de alteração das infrações
  const [listaInfracaoCSV, setListaInfracaoCSV] = useState([]);

  const toggleForm = () => setVisibleForm(!visibleForm);

  //Referencia do relatorio para download do csv
  const exportRef = useRef(null);

  // Headers da exportação do CSV ajustados
  const headersExport = [
    { key: "tipoFiscalizacao", label: "TIPO DE FISCALIZAÇÃO" },
    { key: "identificacao", label: "IDENTIFICAÇÃO DA INFRAÇÃO" },
    { key: "clausula", label: "CLÁUSULA" },
    { key: "valor", label: "VALOR DA MULTA" },
    { key: "valorReincidencia", label: "VALOR DA REINCIDÊNCIA" },
    { key: "tipoInfracao", label: "TIPO DE INFRAÇÃO" },
    { key: "status", label: "STATUS" },
    { key: "codigoTipoServico", label: "CÓDIGO DO TIPO DE SERVIÇO" }
  ];

  const [campos] = useState([
    objCampo({ name: "identificacao", required: true }),
    objCampo({ name: "clausula", required: true }),
    objCampo({ name: "tipoInfracao", required: true }),
    objCampo({ name: "codigoTipoServico", required: true }),
  ]);

  const headers = [
    { value: "Identificação", objectValue: "identificacao", align: "left" },
    { value: "Status", objectValue: "status", align: "left" }
  ];

  const onChange = (e) => {
    const { name, value } = e.target;
    const _infracao = { ...infracao, [name]: value };
    const _campos = campos.filter(campo => campo.name === name);
    const fieldError = validarCampos(_infracao, _campos);
    const _errors = { ...errors };
    delete _errors[name];
    if (fieldError[1].length === 0) setErrors({ ..._errors });
    else setErrors({ ..._errors, ...fieldError[0] });
    setInfracao(_infracao);
  };

  const onSubmit = async () => {
    const _errors = validarCampos(infracao, campos);
    setErrors(_errors[0]);
    if (_errors[1].length > 0) return true;

    const _infracao = { ...infracao };
    _infracao.id = !!_infracao.id ? _infracao.id : 0;
    _infracao.valor = _infracao.valor.replace(",", ".");
    _infracao.valorReincidencia = _infracao.valorReincidencia.replace(",", ".");
    _infracao.secretaria_Id = session.secretaria_Id;
    _infracao.tipofiscalizacao_Id = tipofiscalizacao_Id;

    delete _infracao.infracaoHistoricos;

    try {
      setLoading(true);
      if (!!infracao.id) await infracoes_api.put(_infracao);
      else await infracoes_api.post(_infracao);

      showMessage("Aviso", "Operação realizada com sucesso", "success", () => {
        setListaHistoricoInfracao([])
        setInfracao(initialStateInfracao());
        toggleForm();
        loadInfracoes();
      });
    } catch (err) {
      showMessage("Error", err?.message ?? "Erro na operação.", "error", () => {
        setInfracao(initialStateInfracao());
        toggleForm();
      });
    } finally {
      setLoading(false);
    }
  };

  const loadInfracoes = async () => {
    try {
      setLoading(true);
      const { data } = await infracoes_api.getList(tipofiscalizacao_Id);
      setInfracoes(data);

      const respostaReajustes = await infracoes_api.GetReajustes(tipofiscalizacao_Id);
      setReajustes(respostaReajustes.data ?? []);
    } catch (err) {
      showMessage("Error", err?.message ?? "Erro na operação.", "error", null);
    } finally {
      setLoading(false);
    }
  };

  const actions = [actionsTable.editar(async (rowData) => {
    setLoading(true);
    try {
      const { data } = await infracoes_api.getItem(rowData.id);
      data.valor = data.valor.toFixed(2).replace(".", ",");
      data.valorReincidencia = data?.valorReincidencia ? data.valorReincidencia.toFixed(2).replace(".", ",") : "0,00";
      setInfracao(data);
      setListaHistoricoInfracao(data?.infracaoHistoricos?.map(value => {
        value.valorOriginal = value.valorOriginal.toFixed(2).replace(".", ",");
        value.valorAtualizado = value.valorAtualizado.toFixed(2).replace(".", ",");
        value.atoAdministrativo = value.atoAdministrativo ?? "-";
        value.vigenciaReajuste = value.infracaoReajuste_Id
          ? `${moment(value.inicioVigenciaReajuste).format("DD/MM/YYYY")} a ${moment(value.fimVigenciaReajuste).format("DD/MM/YYYY")}`
          : "-";
        value.dataAtualizacao = moment(value.dataAtualizacao).format("DD/MM/YYYY HH:mm:ss");
        value.usuario = value?.nomeUsuario ?? "";
        return value
      }) ?? [])
      toggleForm();
    } catch (e) {
      showMessage("Erro", e.message, "error", null);
    } finally {
      setLoading(false);
    }
  })];

  async function handleExportInfracoes() {
    setLoading(true);
    try {
      const { data } = await infracoes_api.ExportCSVInfracoes(tipofiscalizacao_Id);
      const _dataTransformada = (data ?? []).map(item => ({
        ...item,
        valor: Number(item.valor).toFixed(2).replace(".", ","),
        valorReincidencia: item.valorReincidencia
          ? item.valorReincidencia.toFixed(2).replace(".", ",")
          : "0,00",
      }));

      setListaInfracaoCSV(_dataTransformada);

      setTimeout(() => {
        exportRef.current.link.click();
      }, 100);
    } catch (error) {
      showMessage("Erro", error?.message ?? "Erro ao exportar infrações", "error", null);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadInfracoes();
  }, []);

  return <>
    <h5 className='mb-3 d-flex align-items-center justify-content-between'>
      <Button onClick={handleVoltar}>
        <FontAwesomeIcon icon={faAngleLeft} className='me-2' /> Voltar
      </Button>

      <div className='d-flex gap-2'>
        {podeRecalcular && infracoes.length > 0 &&
          <Button
            color='dark'
            className='ms-2 text-white'
            onClick={() => setOpenRecalculoModal(true)}
            disabled={possuiReajusteAgendado}
            title={possuiReajusteAgendado ? "Já existe um reajuste agendado para este tipo de fiscalização." : undefined}
          >
            Recalcular Infrações
          </Button>
        }
        {editavel &&
          <Button
            color='success'
            onClick={() => {
              setInfracao(initialStateInfracao());
              setListaHistoricoInfracao([])
              toggleForm();
            }}
          >
            + Adicionar
          </Button>
        }
      </div>
    </h5>

    {podeRecalcular && possuiReajusteAgendado &&
      <div className='alert alert-warning'>
        Já existe um reajuste agendado para este tipo de fiscalização. Cancele-o para agendar outro.
      </div>
    }

    <div className={`formContainer mb-3 ${!visibleForm ? "close" : ""}`}>
      <Row>
        <Col md="12" lg="12">
          <TextField
            label="* Identificação"
            name={"identificacao"}
            onChange={onChange}
            value={infracao.identificacao}
            invalid={!!errors.identificacao}
            maxLength={1000}
            disabled={!editavel}
          />
        </Col>
        <Col md="12" lg="12">
          <TextField
            label="* Cláusula"
            name={"clausula"}
            onChange={onChange}
            value={infracao.clausula}
            invalid={!!errors.clausula}
            disabled={!editavel}
          />
        </Col>
        <Col md="12" lg="4">
          <TextField
            type={"text"}
            name={"codigoTipoServico"}
            label={"* Código Boleto Infração"}
            value={infracao.codigoTipoServico}
            onChange={onChange}
            mask={mascaras.numeroMask}
            maxLength={10}
            invalid={!!errors.codigoTipoServico}
            disabled={!editavel}
          />
        </Col>
        <Col md="12" lg="4">
          <TextField
            type={'select'}
            label="* Status"
            name={"status"}
            options={[
              { value: "Ativo", label: "Ativo" },
              { value: "Inativo", label: "Inativo" }
            ]}
            onChange={onChange}
            value={infracao.status}
            invalid={!!errors.status}
            disabled={!editavel}
          />
        </Col>
        <Col md="12" lg="4">
          <TextField
            type={'select'}
            label="* Tipo de Infração"
            name={"tipoInfracao"}
            options={[
              { value: "Multa", label: "Multa" },
              { value: "Notificação", label: "Notificação" }
            ]}
            onChange={onChange}
            value={infracao.tipoInfracao}
            invalid={!!errors.tipoInfracao}
            maxLength={100}
            disabled={!editavel}
          />
        </Col>
        {infracao.tipoInfracao === "Multa" &&
          <>
            <Col md="12" lg="6">
              <TextField
                type={'text'}
                label="* Valor"
                mask={mascaras.floatMask}
                name={"valor"}
                onChange={onChange}
                value={infracao.valor}
                invalid={!!errors.valor}
                maxLength={100}
                disabled={!editavel}
              />
            </Col>
          </>
        }
        <Col md="12" lg={infracao.tipoInfracao === "Multa" ? 6 : 12}>
          <TextField
            type={'text'}
            label="*  Valor Reincidência"
            mask={mascaras.floatMask}
            name={"valorReincidencia"}
            onChange={onChange}
            value={infracao.valorReincidencia}
            maxLength={100}
            disabled={!editavel}
          />
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col md="12" lg="12" className={`d-flex align-items-center justify-content-center gap-3 ${editavel ? "" : "d-none"}`}>
          <Button
            className='px-4'
            color={'secondary'}
            onClick={() => {
              setInfracao(initialStateInfracao());
              toggleForm();
            }}
          >
            Cancelar
          </Button>
          <Button className='px-4' color={infracao.id ? 'warning text-white' : 'success'} onClick={onSubmit}>
            {infracao.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}
          </Button>
        </Col>
      </Row>

      {listaHistoricoInfracao.length > 0 &&
        <Row className='mt-3'>
          <TabelaListagem
            title={"Lista Históricos de Alterações"}
            headers={[
              { value: "Data/Hora", objectValue: "dataAtualizacao", align: "left" },
              { value: "Usuário", objectValue: "usuario", align: "left" },
              { value: "Valor Original", objectValue: "valorOriginal", align: "left" },
              { value: "Valor Atualizado", objectValue: "valorAtualizado", align: "left" },
              { value: "Observação", objectValue: "observacao", align: "left" },
              { value: "Ato Administrativo", objectValue: "atoAdministrativo", align: "left" },
              { value: "Vigência", objectValue: "vigenciaReajuste", align: "left" },
            ]}
            items={listaHistoricoInfracao}
          />
        </Row>}
    </div>

    {(!visibleForm && !reajusteEmPreparo) &&
      <>
        <TabelaListagem
          actions={actions}
          title={"Lista de Infrações"}
          headers={headers}
          items={infracoes}
          options={{
            print: false,
            search: false,
            customToolbar: infracoes?.length > 0 ? () => (
              <button
                className="tableOption text-success me-3"
                onClick={handleExportInfracoes}
                title="Exportar CSV"
              >
                <FontAwesomeIcon icon={faFileCsv} />
              </button>
            ) : null
          }}
        />

        <CSVLink
          separator={";"}
          data={listaInfracaoCSV}
          headers={headersExport}
          filename="Infrações.csv"
          target="_blank"
          ref={exportRef}
        />

        <HistoricoReajustesInfracoes
          reajustes={reajustes}
          podeRecalcular={podeRecalcular}
          onAlterado={loadInfracoes}
        />
      </>
    }

    {openRecalculoModal && (
      <ModalRecalculoInfracoes
        infracoes={infracoes}
        openRecalculoModal={openRecalculoModal}
        setOpenRecalculoModal={setOpenRecalculoModal}
        setReajusteEmPreparo={setReajusteEmPreparo}
      />
    )}

    {reajusteEmPreparo && (
      <TabelaRecalculoInfracoes
        tipofiscalizacao_Id={tipofiscalizacao_Id}
        reajusteEmPreparo={reajusteEmPreparo}
        setReajusteEmPreparo={setReajusteEmPreparo}
        loadInfracoes={loadInfracoes}
      />
    )}
  </>;
}
